<!-- Main Page Start -->
<div class="content-wrapper table-full-bx">

    <div class="page-content recruiterpanel">

        <div class="row">
            <div class="col-lg-12">
                <div class="ibox ">
                    <div class="ibox-body">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"> <a href="javascript:void(0);"
                                    (click)="moveToPreviousScreenWithQuery()"> Search </a> </li>
                            <li class="breadcrumb-item active">Candidate Detail</li>
                        </ol>
                        <!-- Checkbox -->
                        <div class="d-flex tabBar">
                            <ul class="nav nav-pills job-list joblist1">
                                <li>
                                    <a href="javascript:void(0);" (click)="goToDetail(userID)">Profile</a>
                                </li>
                                <li>
                                    <a href="javascript:void(0);" (click)="goToNotes(userID)">Notes</a>
                                </li>
                                <li class="active">
                                    <a href="javascript:void(0);">Activity</a>
                                </li>
                            </ul>
                            <ul class="nav nav-pills job-list joblist2 pointer">

                                <li (click)="open(sendMail,allData?.user)" title="Send Mail">
                                    <img src="assets/images/ic_email2.svg" class="lm">
                                </li>

                                <li class="share" (click)="openModal(forwordMail,allData)" title="Share">
                                    <img src="assets/images/ic_share.svg" class="lm">
                                    <!-- <div class="socialIcon">
                                     <app-share-button type="facebook" [shareUrl]="link"> </app-share-button>  
                                     <app-share-button type="linkedin" [shareUrl]="link"> </app-share-button>
                                  </div> -->

                                </li>
                                <li (click)="openChatJobView(jobList,allData)" title="Chat">
                                    <img src="assets/images/ic_message2.svg" class="lm">
                                </li>
                                <li (click)="addFav($event,0,allData)" title="Favourite"
                                    *ngIf="allData?.user?.isFavourite == null || allData?.user?.isFavourite == 0">
                                    <img src="assets/images/ic_star.svg" class="lm">
                                </li>
                                <li (click)="addFav($event,1,allData)" title="Favourite" *ngIf="allData?.user?.isFavourite == 1">
                                    <img src="assets/images/ic_favourite_filed.svg" class="lm">
                                </li>


                                <li (click)="onDownlaod(allData?.user?.id)" title="Download">
                                    <img src="assets/images/ic_download2.svg" class="lm">
                                </li>

                                <li (click)="saveNotes($event,allData,saveNote)" title="Notes">
                                    <img src="assets/images/ic_add.svg" class="lm">
                                </li>
                                <li (click)="hideUser()" title="Hide">
                                    <img src="assets/images/ic_close2.svg" class="lm">
                                </li>

                            </ul>
                        </div>
                        <!-- end -->
                        <div class="contentjob">
                            <!-- Basc information -->
                            <div class="row">
                                <div class="col-sm-12 col-lg-12 col-md-12">
                                    <div class="whiteBox">
                                        <div class="basicbox">
                                            <div class="whiteboxinner">
                                                <div class="profileupload ">
                                                    <div class="avatar-preview">
                                                        <div id="imagePreview">
                                                            <img [src]="allData?.user?.profileImage != null ? globalUrl + allData?.user?.profileImage : 'assets/images/profile-img.jpg'"
                                                                alt="profile">
                                                        </div>
                                                    </div>
                                                    <div class="pofiledetailinner">
                                                        <h5 class="name">{{allData?.user?.name || "-"}} </h5>
                                                        <p class="location"> <img src="assets/images/ic_location.svg"
                                                                alt="location"> {{allData?.user?.location || "-"}}</p>
                                                        <div class="badge"><img src="assets/images/ic_badge.svg"
                                                                alt="badge">
                                                            <p class="orange">{{allData?.user?.militaryJobTitle || "-"}}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="profileadd">
                                                    <a class="para6"><strong>Last activity on- </strong>:
                                                        {{allData?.user?.createdAt | date}}</a>

                                                </div>
                                            </div>
                                            <p class="para4">{{allData?.user?.bio || "-"}}</p>



                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div class="flexbox">

                            <div class="iboxcontent">
                                <h3>Activity</h3>

                            </div>
                            <div class="input-group-icon input-group-icon-left ">

                                <div class="ibox-tools">
                                    <div class="col-list-right">
                                        <ul>
                                            <li>Filter By:</li>
                                            <li class="services">
                                                <select class="form-control" (click)="filterApply($event)">
                                                    <option value="0">All</option>
                                                    <option value="1">Self</option>
                                                </select>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="table-scroll table-wrapper">
                            <table id="example" class="table table-striped table-bordered table-hover"
                                style="width:100%">
                                <thead>
                                    <tr>
                                        <th class="width-auto">Date</th>
                                        <th class="width-auto">Activity</th>
                                        <th class="width-auto">User</th>

                                    </tr>
                                </thead>

                                <tbody>
                                    <!-- 1 -->
                                    <tr class="backgroundtable"
                                        *ngFor="let data of ListData | paginate: { id:'pagination', itemsPerPage: pagination.limit, currentPage: currentPage ,totalItems: pagination.totalItems};let i=index">
                                        <td><a>{{data.updatedAt | date: "d/M/YYYY h:mm a"}}</a></td>
                                        <td><a>
                                            <span *ngIf="data.actionType == 0">View</span>
                                            <span *ngIf="data.actionType == 1">Download </span>
                                            <span *ngIf="data.actionType == 2">Mail Sent</span>
                                            <span *ngIf="data.actionType == 3">Favourite </span>
                                            <span *ngIf="data.actionType == 4"> Hide or Skip</span>
                                            <span *ngIf="data.actionType == 5"> Forward</span>
                                            <span *ngIf="data.actionType == 6"> Note</span>
                                            <span *ngIf="data.actionType == 7"> Message</span>
                                        </a></td>
                                        <td><a>{{data.recruiterName || "-"}} | {{data.recruiterEmail || "-"}}</a></td>
                                    </tr>
                                </tbody>
                            </table>
                            <div class="noDataFound" *ngIf="ListData == 0">
                                <h2>No records found</h2>
                            </div>
                        </div>
                        <div class="col-sm-12 p-0">
                            <ul class="pagination ">
                                <pagination-controls id="pagination" (pageChange)="pageChanged($event)"
                                    previousText="&#60;" nextText="Next" firstText="&#62;"
                                    lastText="Last"></pagination-controls>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- job list -->

<ng-template #jobList>
    <div class="modal-body addModal text-left chatTable"> 
        <h4 class="pageTitle">Job List</h4>
        <div class="table-wrapper table-scroll table-responsive mt-3">
            <table id="example" class="table table-hover m-0 table-bordered" style="width:100%;">

                <thead>
                    <tr>
                        <th>Job Id </th>
                        <th>Job title</th>
                        <th>Post Date</th>
                        <th>User </th>
                        <th>Status</th>
                    </tr>
                </thead>

                <tbody>
                    <!-- 1 -->
                    <tr
                        *ngFor="let jobData of allJobsList | paginate: { id:'paginationList', itemsPerPage: paginationList.limit, currentPage: currentPagejobList ,totalItems: paginationList.totalItems};let i=index">
                        <td><a href="javascript:void(0);" class="jobid"> <div class="checkBox_set"><label class="checkbox leftlabel">
                            <input type="checkbox" (change)="userSelect($event,i)"
                                [(ngModel)]="jobData.IsSelete"><i class="input-helper"></i>
                        </label>
                    </div> {{jobData.newId}}</a></td>
                        <td><a href="javascript:void(0);" >{{jobData.jobTitle}}</a></td>
                        <td><a href="javascript:void(0);" >{{jobData.createdAt | date:
                                "d/M/YYYY"}}</a></td>
                        <td><a href="javascript:void(0);" >
                                <span *ngIf="jobData.userType=='SUPER_RECRUITER'"
                                    style="display: inline;">{{jobData?.recruiterName}}</span>
                                <span *ngIf="jobData.userType=='SUB_RECRUITER'"
                                    style="display: inline;">{{jobData?.subRecruiterName}}</span>
                            </a></td> 
                        <td>
                            <a href="javascriot:void(0);">
                                <span class="green"
                                        *ngIf="jobData?.isBlocked == 0 && jobData?.isConfirm == 1">Open</span>
                                <span class="red"
                                        *ngIf="jobData?.isBlocked == 1  && jobData?.isConfirm == 1">Closed</span>
                                <span class="red" *ngIf="jobData?.isConfirm == 0">Draft</span>
                            </a>
                        </td> 
                    </tr>
                </tbody>
            </table>

            <div class="noDataFound" *ngIf="allJobsList == 0">
                <h2>No records found</h2>
            </div>
        </div> 
        <div class="col-sm-12 p-0" *ngIf="totalJobCount > 0">
            <ul class="pagination ">
                <pagination-controls id="paginationList" (pageChange)="pageChangedList($event)"
                    previousText="&#60;" nextText="Next" firstText="&#62;"
                    lastText="Last"></pagination-controls>
            </ul>
        </div>
    </div>
</ng-template>
  
<ng-template #saveNote>
    <div class="modal-body addModal text-left">
        <form [formGroup]="saveNoteForm" (ngSubmit)="onSaveNote()">
            <h4 class="uppercasetext">Create note for {{allData?.user?.name || "-"}}</h4>
            <div class="form-group">
                <label> Status : </label>
                <select class="form-control" formControlName="status">
                    <option value="0"> Pending</option>
                    <option value="1"> Shortlist</option>
                    <option value="2"> Rejected</option>
                    <option value="3"> On Hold</option>
                    <option value="4">BV not cleared</option>
                    <option value="5">Hired</option>
                </select>
            </div>
            <div class="form-group">
                <label>Note</label>
                <textarea class="form-control" placeholder="Enter Note here..." formControlName="note"
                    maxlength="2000"></textarea>
                <p class="para5 text-left m-0">{{saveNoteForm?.value?.note?.length}}/2000</p>
            </div>
            <div class="d-flex">

                <div class="form-group">
                    <a href="javascript:void(0);" class="planbtn greyBtn" (click)="close()">Cancel</a>
                </div>
                <div class="form-group">
                    <input type="submit" value="Save" class="planbtn fill">
                </div>

            </div>
        </form>
    </div>
</ng-template>

<ng-template #sendMail>
    <div class="modal-body addModal text-left">
        <form class="mailTemplate" [formGroup]="mailSendForm" (ngSubmit)="onSendMail()">
            <h4 class="pageTitle upper">Email Candidate</h4>
            <div class="form-group">
                <div class="d-flex">
                    <label>To:</label>
                    <input type="text" class="form-control" placeholder="Enter" formControlName="toEmail">
                    <div class="text-danger" *ngIf="mailSendForm.controls['toEmail'].hasError('required') && showError">
                        *Please Enter To address.
                    </div>
                    <div class="text-danger" *ngIf="mailSendForm.controls['toEmail'].hasError('pattern') && showError">
                      *Please enter valid email.
                    </div> 
                </div>
            </div>
            <div class="form-group">
                <div class="d-flex">
                    <label>Template:</label>
                    <select class="form-control" (change)="onTemplateTypeSelect($event)">
                        <option selected disabled>Please select</option>
                        <option value="-1">None</option>
                        <option *ngFor="let tem of templateData; let i=index" [value]="i">{{tem.actionType}}</option>
                    </select>
                </div>
            </div>
            <div class="form-group">
                <div class="d-flex">
                    <label>Subject:</label>
                    <input type="text" class="form-control" placeholder="Enter" formControlName="subject">
                    <div class="text-danger" *ngIf="mailSendForm.controls['subject'].hasError('required') && showError">
                        *Please Enter subject.
                    </div>
                </div>
            </div>
            <div class="form-group">
                <textarea class="form-control pdding-10" placeholder="Please write here" maxlength="2000"
                    formControlName="message"></textarea>
                <div class="text-danger" *ngIf="mailSendForm.controls['message'].hasError('required') && showError">
                    *Please Enter Template.
                </div>
                <div class="text-danger" *ngIf="mailSendForm.controls['message'].invalid && showError">
                    *Please add follow placeholder mentioned below to send mail.
                </div>
            </div>
            <div class="text-right">
                <div class="form-group text-right">
                    <a href="javascript:void(0);" class="planbtn greyBtn" (click)="modalRef?.hide()">Cancel</a>
                    <input type="submit" value="Send" class="planbtn fill">
                </div>

            </div>

            <div class="instruction">
                <h5><img src="../../../../assets/images/info-circle.svg" alt="info-circle"> The following place holders
                    are allowed:</h5>
                <ul>
                    <li>
                        • &#10100;&#10100;USERNAME&#10101;&#10101; - Username for whom the mail will be sent
                    </li>
                    <li>
                        • &#10100;&#10100;USERFULLNAME&#10101;&#10101; - Sender’s full name
                    </li>
                    <li>
                        • &#10100;&#10100;MYEMAIL&#10101;&#10101; - Sender’s email address
                    </li>
                    <li>
                        • &#10100;&#10100;EMAIL&#10101;&#10101; - Recipient’s email address
                    </li>
                    <li>
                        • &#10100;&#10100;ORGANIZATIONNAME&#10101;&#10101; - Organization Name for which the Action is
                        performed
                    </li>
                </ul>
            </div>
        </form>
    </div>
</ng-template>

<ng-template #forwordMail>
    <div class="modal-body addModal text-left">
        <form class="mailTemplate" [formGroup]="mailForwardForm" (ngSubmit)="onForwardMail()">
            <h4 class="pageTitle upper">Forward Candidate Details ({{userName}})</h4>
            <div class="form-group">
                <div class="d-flex">
                    <label>To:</label>
                    <input type="text" class="form-control" placeholder="Enter" formControlName="toEmail">
                    <div class="text-danger"
                        *ngIf="mailForwardForm.controls['toEmail'].hasError('required') && showError">
                        *Please Enter To address.
                    </div>
                    <div class="text-danger"
                        *ngIf="mailForwardForm.controls['toEmail'].hasError('pattern') && showError">
                        *Please Enter valid email address.
                    </div>
                </div>
            </div>
            <div class="form-group">
                <div class="d-flex">
                    <label>Job Title:</label>
                    <input type="text" class="form-control" placeholder="Enter" formControlName="jobTitle">
                    <div class="text-danger"
                        *ngIf="mailForwardForm.controls['jobTitle'].hasError('required') && showError">
                        *Please Enter job title.
                    </div>
                </div>
            </div>
            <div class="form-group">
                <div class="d-flex">
                    <label>Subject:</label>
                    <input type="text" class="form-control" placeholder="Enter" formControlName="subject">
                    <div class="text-danger"
                        *ngIf="mailForwardForm.controls['subject'].hasError('required') && showError">
                        *Please Enter subject.
                    </div>
                </div>
            </div>
            <div class="form-group">
                <div class="d-flex">
                    <label>Candidates:</label>
                    <input type="text" class="form-control" placeholder="Enter" formControlName="candidate">
                    <div class="text-danger"
                        *ngIf="mailForwardForm.controls['candidate'].hasError('required') && showError">
                        *Please Enter candidate name.
                    </div>
                </div>
            </div>
            <div class="form-group">
                <textarea class="form-control pdding-10" placeholder="Please write here" maxlength="2000"
                    formControlName="message"></textarea>
                <div class="text-danger" *ngIf="mailForwardForm.controls['message'].hasError('required') && showError">
                    *Please Enter message.
                </div>
            </div>
            <div class="text-right">
                <div class="form-group text-right buttonWrap">
                    <a href="javascript:void(0);" class="planbtn greyBtn" (click)="modalRef?.hide()">Cancel</a>
                    <input type="submit" value="Forward Details" class="planbtn fill largeBtn">
                </div>

            </div>
        </form>
    </div>
</ng-template>